export default __webpack_public_path__ + "static/SharedServices-af91935c212bab60cd7e1359ea418766.jpg";